import React, { Component } from 'react'
import { FormGroup, FormControlLabel } from '@material-ui/core'
import Switch from '@material-ui/core/Switch'
import { connect } from 'react-redux'
import * as actions from '../actions'
import { FORM_PROCESO_CALADO } from '../../../config/forms'
import { reduxForm, formValueSelector } from 'redux-form'

const selector = formValueSelector(FORM_PROCESO_CALADO)

class CaladoSwitch extends Component {
  constructor (props) {
    super(props)
    this.updateSiloAparte = this.updateSiloAparte.bind(this)
    this.updateFumigado = this.updateFumigado.bind(this)
    this.updateZarandeo = this.updateZarandeo.bind(this)
    this.updatePendienteAutorizar = this.updatePendienteAutorizar.bind(this)
  }

  componentDidMount () {
    const {
      cea,
      pendienteAutorizarInicial,
      siloAparteInicial
    } = this.props
    this.props.updateSiloAparte(siloAparteInicial)
    this.props.updatePendienteAutorizar(pendienteAutorizarInicial)
    if (cea && cea.fumigado) {
      this.props.updateFumigado(cea.fumigado)
    } else {
      this.props.updateFumigado(false)
    }

    if (cea && cea.zarandeo) {
      this.props.updateZarandeo(cea.zarandeo)
      if (cea.motivoDeZarandeo) {
        this.props.updateMotivoDeZarandeo(cea.motivoDeZarandeo)
      }
    } else {
      this.props.updateZarandeo(false)
      this.props.updateMotivoDeZarandeo(null)
    }
  }

  updateSiloAparte (e, checked) {
    this.props.updateSiloAparte(checked)
  }

  updateFumigado (e, checked) {
    this.props.updateFumigado(checked)
  }

  updateZarandeo (e, checked) {
    this.props.updateZarandeo(checked)
    if (checked) {
      console.log('guardar motivo')
    }
  }

  updatePendienteAutorizar (e, checked) {
    this.props.updatePendienteAutorizar(checked)
  }

  render () {
    const {
      cea,
      fumigado,
      siloAparte,
      zarandeo,
      pendienteAutorizar
    } = this.props

    return (
      <FormGroup name='switches-calado'>
        <FormControlLabel control={<Switch
          color='primary'
          name='siloAparte'
          onChange={this.updateSiloAparte}
          checked={siloAparte}
        />}label='Condicional silo aparte' />
        <FormControlLabel control={<Switch
          color='primary'
          name='fumigado'
          checked={fumigado}
          onChange={this.updateFumigado}
        />}label='Fumigado' />
        <FormControlLabel control={<Switch
          color='primary'
          name='zarandeo'
          checked={zarandeo}
          disabled
          onChange={this.updateZarandeo}
        />}label='Zarandeo' />
        <FormControlLabel control={<Switch
          color='primary'
          name='pendienteAutorizar'
          onChange={this.updatePendienteAutorizar}
          checked={pendienteAutorizar}
          disabled={cea.rechazoAdministrativoCalado ? cea.rechazoAdministrativoCalado === 'P' : false}
        />}label='Pendiente autorizar' />
      </FormGroup>
    )
  }
}

const mapStateToProps = (state) => ({
  cea: state.calado.consultaCea || {},
  calificaciones: state.calado.calificaciones,
  estadoCondicionSwitch: state.calado.estadoCondicionSwitch,
  fumigado: state.calado.fumigado,
  siloAparte: state.calado.siloAparte,
  siloAparteInicial: selector(state, 'siloAparte'),
  pendienteAutorizar: state.calado.pendienteAutorizar,
  pendienteAutorizarInicial: selector(state, 'pendienteAutorizar'),
  zarandeo: state.calado.zarandeo
})

const withRedux = connect(mapStateToProps, actions)

const withReduxForm = reduxForm({
  form: FORM_PROCESO_CALADO,
  enableReinitialize: true,
  keepDirtyOnReinitialize: false,
  destroyOnUnmount: false,
  updateUnregisteredFields: true
})

export default withRedux(withReduxForm(CaladoSwitch))
